module.exports = __webpack_public_path__ + "static/usecase_payment_profile@2x-fedae906a78bb4b733804171329230dd.png";